export const GO='ALARM/THRESHOLD/GO';

export const THRESHOLD_LIST ='ALARM/THRESHOLD_LIST';